/**
 * The type of (redux) action which dismisses calendar notification.
 *
 * {
 *     type: DISMISS_CALENDAR_NOTIFICATION
 * }
 */
export const DISMISS_CALENDAR_NOTIFICATION = 'DISMISS_CALENDAR_NOTIFICATION';
